import { ActivatedRoute } from '@angular/router';
import { IRoute } from 'viggo-sistemas-core-web';


/**
 * Valida as rotas do usuário
 * @param routes
 * @param url_name
 * @returns
 */
export function verificarRotasDeAcessoRaiz(routes: IRoute[], url_name: string): IRoute[] {
  if (routes && routes.length > 0 && url_name) {
    return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
  }
}

/**
 * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
 * @param routesAuthorization
 * @param action
 * @param params
 * @param url_name
 * @returns
 */
export function validarAdicaoRaiz(routesAuthorization: IRoute[],action: string,params = '',url_name: string): boolean {
  if (routesAuthorization && routesAuthorization.length > 0) {
    const url_return = routesAuthorization.find(
      route => route.url === url_name && route.method === action
    );
    return url_return ? true : false;
  }
}

/**
 * Deixei esse comentário para os do futuro, eu sou optimus prime e essa função
 * funciona com base na key de acesso vinda do resolver é realizado um filtro dentro
 * de todas as rotas adicionadas como políticas de acesso para a aplicação e
 * o papel do usuário. Após mapear é armazenado na váriavel routesAuthorization as
 * rotas que coincidem com a fast_backend_path que deve ser determinada no .module
 */
export function verficarRotasDeAcesso(routes : IRoute[], actRoute: ActivatedRoute, routesAuthorization : IRoute[]):IRoute[] {
  const url = actRoute.snapshot.data.fast_backend_path;
  if (routes.length > 0 && url) {
    return routesAuthorization = url.map(url=>routes.filter(r =>
      new RegExp(`^${url}`).test(r.url)
    ));
  }
}

/**
 * Após o mapeamento é realizado um outro filtro agora dentre as rotas autorizadas
 * Nesse filtro é verificado a action da url e seu conteúdo
 * @param action métodos HTTP (POST,PUT,DELETE,GET)
 * @param params (opcional) corresponde ao restante da url ex: /<id>/supervisor
 * @returns true para o caso de ter acesso e false para o caso de não ter
 */
export function validarAdicao (actRoute: ActivatedRoute, routesAuthorization : IRoute[], action: string, params = '', url_name: string): string {
  const url = actRoute.snapshot.data.fast_backend_path;
  let actions : IRoute[] = []
  if(routesAuthorization && routesAuthorization.length > 0){
    routesAuthorization.map(
      route => {
        for(let aux in route){
          for(let aux1 in url){
              if(route[aux].method === action && route[aux].url === `${url[aux1]}${params}`)
                  actions.push(route[aux])
            }
          }
        }
      );
    const url_return = actions.filter(r => r.url === url_name)
    return url_return[0] !== undefined?url_return[0].url:''
  }
};
